export default __webpack_public_path__ + "static/media/1104.2a30ebb7.jfif";